// client/src/components/watchdog/WatchdogConfigPanel.jsx
import React, { useState, useEffect } from "react";

const s = {
    panel: {
        background: "#1a1f2e",
        borderRadius: "12px",
        padding: "16px 20px",
        border: "1px solid #1e293b",
        marginBottom: "20px",
    },
    row: {
        display: "flex",
        alignItems: "center",
        gap: "20px",
        flexWrap: "wrap",
    },
    label: {
        color: "#94a3b8",
        fontSize: "12px",
        fontWeight: 600,
        marginBottom: "4px",
    },
    select: {
        background: "#0f1219",
        border: "1px solid #334155",
        borderRadius: "6px",
        color: "#e2e8f0",
        padding: "6px 10px",
        fontSize: "13px",
        cursor: "pointer",
    },
    input: {
        background: "#0f1219",
        border: "1px solid #334155",
        borderRadius: "6px",
        color: "#e2e8f0",
        padding: "6px 10px",
        fontSize: "13px",
        width: "80px",
    },
    toggle: (on) => ({
        width: 42,
        height: 22,
        borderRadius: 11,
        background: on ? "#22c55e" : "#334155",
        cursor: "pointer",
        position: "relative",
        transition: "background 0.2s",
        border: "none",
        flexShrink: 0,
    }),
    toggleDot: (on) => ({
        width: 16,
        height: 16,
        borderRadius: 8,
        background: "#fff",
        position: "absolute",
        top: 3,
        left: on ? 23 : 3,
        transition: "left 0.2s",
    }),
    saveBtn: {
        background: "#6366f1",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        padding: "6px 16px",
        fontSize: "12px",
        fontWeight: 600,
        cursor: "pointer",
    },
    modeTag: (mode) => ({
        display: "inline-block",
        padding: "2px 8px",
        borderRadius: "4px",
        fontSize: "11px",
        fontWeight: 700,
        background: mode === "auto_execute" ? "#ef444420" : "#06b6d420",
        color: mode === "auto_execute" ? "#ef4444" : "#06b6d4",
        letterSpacing: "0.5px",
    }),
    errorBar: {
        marginTop: "10px",
        padding: "8px 12px",
        background: "rgba(239, 68, 68, 0.1)",
        border: "1px solid rgba(239, 68, 68, 0.3)",
        borderRadius: "6px",
        color: "#fca5a5",
        fontSize: "12px",
    },
};

export default function WatchdogConfigPanel({ config, saving, onSave, onModeChange, error }) {
    const [local, setLocal] = useState({
        watchdog_enabled: true,
        watchdog_mode: "monitor_only",
        watchdog_debounce_ms: 5000,
        watchdog_concurrency: 4,
    });

    useEffect(() => {
        if (config) setLocal({ ...config });
    }, [config]);

    const handleModeChange = (e) => {
        const newMode = e.target.value;
        if (onModeChange) {
            // Let parent handle confirmation for auto_execute
            onModeChange(newMode);
        } else {
            setLocal(p => ({ ...p, watchdog_mode: newMode }));
        }
    };

    const handleSave = () => {
        onSave(local);
    };

    if (!config) return null;

    return (
        <div style={s.panel}>
            <div style={s.row}>
                <div>
                    <div style={s.label}>Enabled</div>
                    <button
                        style={s.toggle(local.watchdog_enabled)}
                        onClick={() => setLocal(p => ({ ...p, watchdog_enabled: !p.watchdog_enabled }))}
                    >
                        <div style={s.toggleDot(local.watchdog_enabled)} />
                    </button>
                </div>

                <div>
                    <div style={s.label}>Mode</div>
                    <select
                        style={s.select}
                        value={local.watchdog_mode}
                        onChange={handleModeChange}
                    >
                        <option value="monitor_only">Monitor Only</option>
                        <option value="auto_execute">Auto Execute</option>
                    </select>
                </div>

                <div>
                    <div style={s.label}>Debounce (ms)</div>
                    <input
                        style={s.input}
                        type="number"
                        value={local.watchdog_debounce_ms}
                        onChange={e => setLocal(p => ({ ...p, watchdog_debounce_ms: parseInt(e.target.value) || 5000 }))}
                    />
                </div>

                <div>
                    <div style={s.label}>Concurrency</div>
                    <input
                        style={s.input}
                        type="number"
                        min={1}
                        max={20}
                        value={local.watchdog_concurrency}
                        onChange={e => setLocal(p => ({ ...p, watchdog_concurrency: parseInt(e.target.value) || 4 }))}
                    />
                </div>

                <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "12px" }}>
                    <span style={s.modeTag(local.watchdog_mode)}>
                        {local.watchdog_mode === "auto_execute" ? "AUTO EXECUTE" : "MONITOR ONLY"}
                    </span>
                    <button style={s.saveBtn} onClick={handleSave} disabled={saving}>
                        {saving ? "Saving..." : "Save"}
                    </button>
                </div>
            </div>

            {error && (
                <div style={s.errorBar}>
                    Save failed: {error}
                </div>
            )}
        </div>
    );
}
